export const itemsToFetchMap = [5, 10, 20, 50, 100];
